<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="357"> </caass-schoolselector>
						</div>
					</div>

					<!--InstructorPersonID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Instructor</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="InstructorID" [(ngModel)]="report.InstructorID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of InstructorList" [ngValue]="o.Teacher_PersonID">
									{{ o.Instructor }}
								</option>
							</select>
						</div>
					</div>

					<!--GradeLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--AcademyID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AcademyList" [ngValue]="o.AcademyId">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--HomeroomID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeroomID" [(ngModel)]="report.HomeroomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of HomeroomList" [ngValue]="o.HomeroomId">
									{{ o.HomeRoom }}
								</option>
							</select>
						</div>
					</div>

					<!--GROUPID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupID" [(ngModel)]="report.GroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupList" [ngValue]="o.GroupID">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--STARTDATE-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.STARTDATE" name="txtSTARTDATE"></p-calendar>
						</div>
					</div>

					<!--ENDDATE-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.ENDDATE" name="txtENDDATE"></p-calendar>
						</div>
					</div>

					<!--MeritType-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Merit Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="MeritTypeID" [(ngModel)]="report.MeritTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MeritTypeList" [ngValue]="o.MeritTypeID">
									{{ o.MeritTypeName }}
								</option>
							</select>
						</div>
					</div>

					<!--GroupPeriods-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group Periods</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupPeriodsID" [(ngModel)]="report.GroupPeriodsID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupPeriodsList" [ngValue]="o.GroupPeriodsID">
									{{ o.GroupPeriodsName }}
								</option>
							</select>
						</div>
					</div>

					<!--PageBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Page By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PageByID" [(ngModel)]="report.PageByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PageByList" [ngValue]="o.PageByID">
									{{ o.PageByName }}
								</option>
							</select>
						</div>
					</div>

					<!--ShowStudentName-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Student Name</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ShowStudentNameID" [(ngModel)]="report.ShowStudentNameID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ShowStudentNameList" [ngValue]="o.ShowStudentNameID">
									{{ o.ShowStudentNameName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
